import {BusEventEnum, EventBus} from '@core/eventBus';
import {useUpdateEffect} from '@hooks/useUpdateEffect';
import {useEffect, useRef} from 'react';

/**
 * Runs the effect only if the deps update was not caused by user interaction.
 * User interaction events are sent manually with `emitUserInteractionEvent`.
 */
export const useSkipUserInteractionUpdateEffect = (
    fn: () => void,
    deps: any[],
) => {
    const isUserInteraction = useRef(false);

    useEffect(() => {
        const sub = EventBus.on(BusEventEnum.USER_INTERACTION, () => {
            isUserInteraction.current = true;
        });
        return () => {
            sub.unsubscribe();
        };
    }, []);

    useUpdateEffect(() => {
        if (isUserInteraction.current) {
            isUserInteraction.current = false;
            return;
        }
        fn();
    }, deps);

    return isUserInteraction;
};
